<mbs-modal [isCustomModal]="true">
  <ng-container modal-header>{{ title }}</ng-container>

  <ng-container modal-body>
    <mbs-alert
      *ngIf="!showVariants"
      [type]="alertType"
      [icon]="true"
      class="mb-0">
      {{ text }}
    </mbs-alert>

    <mbs-form-group
      *ngIf="showVariants"
      class="mb-0"
      [title]="'wizards:common.wizardsPlansRunning' | i18next"
      [titleClasses]="'fw-normal'">
      <mbs-radio
        [(ngModel)]="saveVariant"
        name="saveVariant"
        [label]="'wizards:common.applyAfterSave' | i18next"
        [value]="saveVariants.saveAfterStop"
        [id]="'save-variant-1'"></mbs-radio>
      <mbs-radio
        [(ngModel)]="saveVariant"
        name="saveVariant"
        [label]="'wizards:common.stopAndSave' | i18next"
        [value]="saveVariants.stopAndSave"
        [id]="'save-variant-2'"></mbs-radio>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      *ngIf="okButtonText"
      type="primary"
      [id]="'save-button'"
      (click)="save()">
      {{ okButtonText }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      [id]="'close-button'"
      (click)="close()">
      {{ cancelButtonText }}
    </mbs-button>
  </ng-container>
</mbs-modal>
